import { defineEvent } from '../types/event';
export var PDP_VIEW = defineEvent({
    platforms: [
        {
            name: 'Optimizely',
            alias: 'PDP_Pageviews'
        },
        {
            name: 'Heap',
            transform: function (_a) {
                var id = _a.id;
                return ({
                    eventName: 'PDP - View',
                    shopifyProductId: id
                });
            }
        }
    ]
});
